import React, { useState } from "react";
import { useSelector } from "react-redux";

import PrintOut from "../Common/PrintOut";
import InnsynMotorvognFilterContainer from "./InnsynMotorvognFilterContainer";
import InnsynMotorvognInfo from "./InnsynMotorvognInfo";
import NavigationBarContainer from "./NavigationBarContainer";

import sitePaths from "../../constants/sitePaths";

export default function InnsynMotorvognPage() {
  const innsynMotorvogn = useSelector((state) => state.innsynMotorvogn);
  const innsynMotorvognFilterForm = useSelector(
    (state) => state.forms.innsynMotorvognFilterForm,
  );

  const [waitingForGetSingleMotorvognByQuery, setWaiting] = useState(false);

  return (
    <React.Fragment>
      <NavigationBarContainer page="motorvogn" />
      <InnsynMotorvognFilterContainer
        waitingForGetSingleMotorvognByQuery={setWaiting}
      />
      {innsynMotorvogn && innsynMotorvogn.kjennemerke && (
        <div style={{ paddingRight: 50, paddingLeft: 50 }}>
          <div
            style={{
              display: "inline-block",
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            <PrintOut
              url={`${window.location.origin}${sitePaths.innsyn.motorvogn.utskrift}`}
              dataToStoreInSessionStorage={innsynMotorvognFilterForm}
            />
          </div>
          <InnsynMotorvognInfo motorvogn={innsynMotorvogn} />
        </div>
      )}
      {innsynMotorvogn &&
        !innsynMotorvogn.kjennemerke &&
        innsynMotorvogn.hasBeenSubmitted && (
          <div style={{ marginTop: 20, paddingLeft: 50 }}>
            Ingen motorvogn finnes for ditt søk.
          </div>
        )}
    </React.Fragment>
  );
}
